import React from 'react';
import { HeroBanner, TrustBar, ProductCategories, WhyYaadShop, CtaBanner } from '../components/home';
import SEO from '../components/SEO';

const Home: React.FC = () => {
  return (
    <div className="bg-brand-warm">
      <SEO
        description="Canada's multicultural wholesale supplier. B2B bulk pricing on machetes, flags, bandanas, and more for African, Caribbean, Asian & Latin American stores. Based in the GTA."
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "The Yaad Shop",
          "url": "https://theyaadshop.com",
          "logo": "https://theyaadshop.com/images/logo.png",
          "description": "Canada's multicultural wholesale supplier for African, Caribbean, Asian & Latin American stores.",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Toronto",
            "addressRegion": "ON",
            "addressCountry": "CA"
          },
          "areaServed": "CA",
          "contactPoint": {
            "@type": "ContactPoint",
            "email": "info@theyaadshop.com",
            "contactType": "sales"
          }
        }}
      />
      <HeroBanner />
      <TrustBar />
      <ProductCategories />
      <WhyYaadShop />
      <CtaBanner />
    </div>
  );
};

export default Home;
